var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "256", height: "256", viewBox: "0 0 256 256" }, props),
    React.createElement(
      "g",
      { strokeWidth: "0", strokeMiterlimit: "10", fill: "none" },
      React.createElement("path", { d: "M202.577 254.307H53.136c-9.526 0-17.242-7.717-17.242-17.243V18.65c0-9.526 7.716-17.242 17.242-17.242h103.458l63.225 63.225v172.432c0 9.526-7.716 17.243-17.242 17.243z", fill: "#ffba00" }),
      React.createElement("path", { d: "M156.594 1.407l63.225 63.225h-63.225V1.407z", fill: "#ff9500" }),
      React.createElement("path", { d: "M170.965 99.119H70.378v77.595H185.335V99.116h-14.37zm0 63.225H84.748v-48.858h86.217v48.858z", fill: "#fff" })
    )
  );
});